import * as Sentry from '@sentry/react'

import qs from 'qs'

import { initEnvironmentReact } from '../../../initEnvironmentReact'
import { addCdnToUrl } from '../addCdnToUrl'
import { GetAdvertiserLogoPathInterface } from './getAdvertiserLogoPath.types'

const defaultProperties: Omit<GetAdvertiserLogoPathInterface, 'iconName'> = {
  size: 's',
  theme: 'light',
}

export const getAdvertiserLogoPath = (properties: GetAdvertiserLogoPathInterface) => {
  const { iconName, serviceVersionAddString, size, theme } = { ...defaultProperties, ...properties }

  const serviceVersion = import.meta.env.VITE_SERVICE_VERSION || initEnvironmentReact.SERVICE_VERSION
  const serviceVersionQueryString = qs.stringify({ version: serviceVersion + (serviceVersionAddString ? `-${serviceVersionAddString}` : '') })

  if (!iconName) {
    Sentry.captureException(new Error('assets > advertiser logo not passed'))
  }

  return addCdnToUrl(`/assets/img/advertisers/${theme}/${size}/${iconName}.svg?${serviceVersionQueryString}`)
}
